/** 상점 바로머니 일별 상세 엔티티 */
export default class SalesStoreBaromoneyDailyDetail {
    todayNumber = 0;
    hubName = '';
    date = '';
    category = '';
    depositAmount = 0;
    supplyPrice = 0;
    vat = 0;
    hubCacheBalance = 0;
    memo = '';
    receiptNumber = '';
    processor = '';
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
